import Invitations from '../components/invitations/Invitations';
import Notifications from '../components/notifications/Notifications';
import MySubscriptions from '../components/MySubscriptions';
import TeamActions from '../components/invitations/TeamActions';
import UpcomingEvents from '../components/calendar/UpcomingEvents';
import HomeScreenTeamsCard from '../components/teams/HomeScreenTeamsCard';
import PwaSetupCard from '../components/pwa/PwaSetupCard';
import DashboardEventCheckInCard from '../components/eventTickets/DashboardEventCheckInCard';
import DashboardEventTicketCard from '../components/eventTickets/DashboardEventTicketCard';
import './dashboard.css';

export default function Dashboard() {
  return (
    <div className="dashboard-grid">
      <PwaSetupCard surface="dashboard" />
      <div className="dashboard-arrival-tools">
        <DashboardEventCheckInCard /> {/* transient scanner access for authorised event staff */}
        <DashboardEventTicketCard /> {/* transient event and course ticket access near arrival time */}
      </div>
      <HomeScreenTeamsCard /> {/* user-selected club shortcuts */}
      <Invitations />         {/* invite-to-family, clubs, teams */}
      <Notifications />       {/* recent notifications */}
      <UpcomingEvents />      {/* upcoming events for the user */}
      <MySubscriptions />     {/* current subscriptions */}
      <TeamActions />         {/* team admin actions (join + refund requests) */}
    </div>
  );
}
